
import './config'
import account from './account'
import project from './project'
import image from './image'
import team from './team'
import version from './version'

let API = {
    account,
    project,
    image,
    team,
    version
}

export default API 